import { render, staticRenderFns } from "./ReservationMediaCard.vue?vue&type=template&id=183e7170&scoped=true&"
import script from "./ReservationMediaCard.vue?vue&type=script&lang=js&"
export * from "./ReservationMediaCard.vue?vue&type=script&lang=js&"
import style0 from "./ReservationMediaCard.vue?vue&type=style&index=0&id=183e7170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e7170",
  null
  
)

export default component.exports